import React from "react";
import Calendar from "../Calendar";
import DatePicker from "../DatePicker/DatePicker";
import PriceCalendarProvider from "./PriceCalendarContext";
import PriceDateButton from "./PriceDateButton";
const PriceCalendar = ({
  renderDateButton = PriceDateButton,
  ...props
}) => /* @__PURE__ */ React.createElement(Calendar, {
  ...props,
  renderDateButton
});
const PriceCalendarPicker = ({
  prices,
  isLoading,
  renderCalendar = PriceCalendar,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(PriceCalendarProvider, {
    prices,
    isLoading
  }, /* @__PURE__ */ React.createElement(DatePicker, {
    ...props,
    renderCalendar
  }));
};
PriceCalendarPicker.displayName = "Primitives(DateTimePicker.PriceCalendarPicker)";
var PriceCalendarPicker_default = PriceCalendarPicker;
export {
  PriceCalendar,
  PriceCalendarPicker_default as default
};
